import PaymentForm from './paymentForm';

export default PaymentForm;